import { KeyboardEvent, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { REQUIRED_VALIDATION } from '~config'
import { Button, Icon, InputText } from '~design-system'

type Props = {
  id: string
  onSubmit: () => void
  placeholder: string
}

/** Années de 1950 à l'année courante − 2 (ex. en 2026 → jusqu'à 2024). */
const getActiveLifeYearPattern = () => {
  const maxYear = new Date().getFullYear() - 2
  const lastTwo = maxYear - 2000
  const decade = Math.floor(lastTwo / 10)
  const unit = lastTwo % 10

  if (decade === 0) {
    return new RegExp(`^(19[5-9]\\d|200[0-${unit}])$`)
  }

  if (unit === 9) {
    return new RegExp(`^(19[5-9]\\d|20[0-${decade}]\\d)$`)
  }

  return new RegExp(
    `^(19[5-9]\\d|20([0-${decade - 1}]\\d|${decade}[0-${unit}]))$`
  )
}

const InputYear = ({ id, onSubmit, placeholder }: Props) => {
  const {
    setFocus,
    formState: { dirtyFields, errors, isValid },
    register,
  } = useFormContext()

  useEffect(() => {
    setFocus(id)
  }, [id, setFocus])

  const submit = () => {
    if (dirtyFields[id] && isValid) {
      onSubmit()
    }
  }

  const handleKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      submit()
    }
  }

  return (
    <InputText
      id={id}
      label="Année d'entrée dans la vie active"
      errorMessage={errors[id] && errors[id].message}
      placeholder={placeholder}
      onKeyPress={handleKeyUp}
      type="text"
      mt={3}
      rightComponent={
        <Button
          disabled={!dirtyFields[id] || errors[id]}
          onClick={submit}
          size="small"
          square
          title="Envoyer"
        >
          <Icon name="send" />
        </Button>
      }
      {...register(id, {
        ...REQUIRED_VALIDATION,
        pattern: getActiveLifeYearPattern(),
      })}
    />
  )
}

export default InputYear
